
import { Options, mixins } from "vue-class-component";
import { ref } from "vue";
import CashierSession from "../../service/CashierSession";
import UtilityOptions from "../../mixins/UtilityOptions";
import Toaster from "../../helpers/Toaster";

interface IBranch {
  name: string;
}

interface cashierSessionsList {
  salesCash:string,
  salesCard:string,
  salesOther:string,
  refundCash:string,
  refundCard:string,
  refundOther:string,
  otherExpenses:string,
  payLater:string,
  openningBalance:string,
  cashBalance:string,
  salesBalance:string,
  status:string,
  sessionStartedAt:string,
  sessionEndedAt:string,
}

@Options({
  title: 'Cashier Sessions',
  components: {},
})

export default class CashierSessionView extends mixins(UtilityOptions) {
  private dt = ref();
  private lists: cashierSessionsList[] = [];
  // private cashierSession;
  private resultTitle = "";
  private toast;
  private productDialog = false;
  private loading = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
      { label: "Initialization", to: "/store/initialization" },
      { label: "Cashier Sessions", to: "/cashier/cashier-session" },
  ];
  private checkPagination = true;
  private limit = 0;
  private totalRecords = 0;

  private searchFilters = {
      filterType:"None",
      date1: "",
      date2: "",
      createdBy: 0,
      branchId: 0,
      statusId: 0,
  };
  private cashierList;
  private branchList;
  private statusList;
  private filterDates;
  private dialogTitle;
  private submitted = false;
  private filterBranch = [];
  private goToFirstLink = 0;
  private menuBar = false;
  private previewTransactionDialog = false;
  private selectedRow = {
      sessionEndedAt:false,
      paymentTransactions: []
  };
  private item = {
      cashier_id: 0,        
  };

  //CALLING WHENEVER COMPONENT LOADS
  created() {
      this.toast = new Toaster();
  }

  //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
      this.filterList();
      this.loadList(0);
  }

  //OPEN DIALOG TO ADD NEW ITEM
  openDialog() {
      this.submitted = false;
      this.dialogTitle = "Filter Report";
      this.productDialog = true;
  }  
  
  //CLOSE DIALOG
  closeDialog() {
      this.productDialog = false;
  }

  openTransactionDialog() {
      this.previewTransactionDialog = true;
      this.menuBar = false;
  }

  filterList() {
    const cashierSession = new CashierSession();

    cashierSession.cashierSessionFilters()
      .then((res) => {
        if (res.status_id == 1) {
          this.cashierList = res.cashiers;
          this.branchList = res.branches;
          this.statusList = res.statuses;
          this.filterDates = res.dates;
          this.cashierList.push({id:0, name:'All'}); 
          this.branchList.push({id:0, name:'All'}); 
          this.statusList.push({id:0, name:'All'}); 
        } else {
          this.toast.handleResponse(res);
        }
      });
  }

  // USED TO GET SEARCHED ASSOCIATE
  loadList(page) {
    const cashierSession = new CashierSession();

    cashierSession.cashierSessionList(this.searchFilters, page)
      .then((res) => {
        if (res.status_id == 1) {
            const data = this.camelizeKeys(res);
            this.resultTitle = data.resultTitle;
            this.lists = data.cashierSessions;
            this.limit = data.limit;
            this.totalRecords = data.totalRecords;
            this.loading = false;
            this.goToFirstLink = page;
            this.closeDialog();
        } else {
          this.toast.handleResponse(res);
        }
      });
  }

  get rList() {
      const l: cashierSessionsList[] = [];

      this.lists.forEach((e) => {
          l.push(e);
      });

      return l;
  }
  
  //CALLING WHEN PAGINATION BUTTON CLICKS
  onPage(event) {
      this.loadList(event.first);
  }

  openMenu(data) {
      var tempArray = <any> [];
      data.transactions.forEach(element => {
        element.receiptPayments.forEach(subElement => {
          var myObj = {
            createdDate:subElement.createdAt,
            description:subElement.description,
            receiptNo:subElement.receiptNo,
            transAmount:subElement.transAmount,
            paymentType:subElement.paymentType,
            sourceType:subElement.sourceType
          };
          tempArray.push(myObj);
        });

        element.voucher.forEach(subElement => {
          var myObj = {
            createdDate:subElement.createdAt,
            description:subElement.memo,
            receiptNo:subElement.voucherNo,
            transAmount:subElement.totalAmount,
            paymentType:subElement.accountType,
            sourceType:subElement.type
          };
          tempArray.push(myObj);
        });

        element.payLater.forEach(subElement => {
          var myObj = {
            createdDate:subElement.createdAt,
            description:subElement.description,
            receiptNo:subElement.receiptNo,
            transAmount:subElement.transAmount,
            paymentType:'None',
            sourceType: 'INE(Pay Later)'
          };
          tempArray.push(myObj);
        });
      });

      this.selectedRow.sessionEndedAt = data.sessionEndedAt;
      this.selectedRow.paymentTransactions = this.camelizeKeys(
        tempArray
      );
      this.menuBar = true;
      this.item.cashier_id = data.sessionId;
    }
    
  endCashierSession(){
    const cashierSession = new CashierSession();

    cashierSession.logoutCashierByAdmin(this.item.cashier_id)
      .then((res) => {
        if (res.status_id == 1) {
          this.menuBar = false;
          this.loadList(this.goToFirstLink);
          this.toast.showSuccess(res.msg);
        } else {
          this.toast.handleResponse(res);
          this.menuBar = false;
        }
      });
  }
    
  get currency() {
      return this.store.getters.getCurrency;
  }
}
